<label class="box">
	<input type="radio" class="box__radio" [value]="value" name="box" (change)="valueChanged()" />
	<p class="box__text">{{ textItem }}</p>
</label>
